/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_UnlimitedInputs */

const en_why_listening_unlimited = /** @type {(inputs: Why_Listening_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening: unlimited`)
};

const es_why_listening_unlimited = /** @type {(inputs: Why_Listening_UnlimitedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening: ilimitado`)
};

/**
* | output |
* | --- |
* | "Listening: unlimited" |
*
* @param {Why_Listening_UnlimitedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_unlimited = /** @type {((inputs?: Why_Listening_UnlimitedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_UnlimitedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_unlimited(inputs)
	return en_why_listening_unlimited(inputs)
});